/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/plant_medium'
export default icon
